import app from '../../angular_app.es6';
import { find } from "lodash";

app.directive('expressLanguageSwitcher', [ '$rootScope', 'TranslationService', ($rootScope, TranslationService) => {
  return {
    restrict: 'E',
    scope: {
      description: "=",
      languageCode: "=",
      languageName: "=",
      showLanguageSwitcher: "="
    },
    template: require('./express_language_switcher_template.html'),
    link: ($scope) => {

      $scope.needOutput = () => {
        return !!$scope.languageCode && $scope.languageCode != 'en' && $scope.showLanguageSwitcher;
      };

      $scope.languages = [];
      $scope.languageId = Date.now();

      $scope.selectLanguage = (language) => {
        $scope.selectedLanguage = language;
        TranslationService.setisDefaultLanguage($scope.languageCode == $scope.selectedLanguage.code);
        $rootScope.$broadcast("ChangeScorecardLanguage");
      };

      const clearWatcher = $scope.$watch("languageCode", (newVal, oldVal) => {
        if (newVal){
          $scope.translateLanguageCode = "en";

          $scope.languages = [
            {
              name: $scope.languageName,
              code: $scope.languageCode
            },
            {
              name: "English",
              code: $scope.translateLanguageCode
            }
          ];

          $scope.languageId = Date.now();

          $scope.selectedLanguage = TranslationService.isDefaultLanguage() ? $scope.languages[0] : $scope.languages[1];
        }
      });

      $scope.$on("$destroy", () => {
        clearWatcher();
      });
    }
  }
}]);